import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { SignInLHSContainer } from "../components/atoms/Containers";
import { SignUpInfo } from "../components/molecules/overlayBoxes/SignUpInfo";
import { SelectFirstDataSource } from "../components/organisms/dataSource/SelectFirstDataSource";

export const FirstDataSource = () => (
  <Flex
    w="full"
    h="full"
    flexDirection="row"
    justify="flex-end"
    overflow="hidden"
  >
    <Flex w="full" h="full" flex={1} position="relative">
      <SignInLHSContainer>
        <SignUpInfo />
      </SignInLHSContainer>

      <Box
        position="absolute"
        inset={0}
        bg="blackAlpha.600"
        pointerEvents="none"
        zIndex={0}
      />
    </Flex>
    <SelectFirstDataSource />
  </Flex>
);
